export default defineNuxtPlugin((nuxtApp) => {
	const runtimeConfig = useRuntimeConfig()
	const { $apiHelper } = useNuxtApp()

	const buildApiUrl = (appendPath) => {
		return runtimeConfig.public.SERVICES.MOTHERSHIP_API_URL + "user/" + appendPath
	}

	nuxtApp.provide("authApiService", {
		$login: async (requestBody, successHandler) => {
			const url = buildApiUrl("login")

			const requestOptions = {}
			requestOptions.method = "POST"
			requestOptions.body = requestBody

			$apiHelper.$performRequest(url, requestOptions, successHandler)
		},

		$logout: async (requestBody, successHandler) => {
			const url = buildApiUrl("logout")

			const requestOptions = {}
			requestOptions.method = "PATCH"
			requestOptions.headers = $apiHelper.$authedRequestHeader()

			$apiHelper.$performRequest(url, requestOptions, successHandler)
		},

		$forgotPassword: async (requestBody, successHandler) => {
			const url = buildApiUrl("forgot-password")

			const requestOptions = {}
			requestOptions.method = "POST"
			requestOptions.body = requestBody

			$apiHelper.$performRequest(url, requestOptions, successHandler)
		},

		$resetPassword: async (requestBody, successHandler) => {
			const url = buildApiUrl("reset-password")

			const requestOptions = {}
			requestOptions.method = "POST"
			requestOptions.body = requestBody

			$apiHelper.$performRequest(url, requestOptions, successHandler)
		},
	})
})
